export default "__VITE_ASSET__CNxCHpiZ__"